import React from "react";

export default function PageHeader({ title, subtitle, action, testId }) {
  return (
    <div className="flex items-center justify-between mb-6" data-testid={testId}>
      <div>
        <h1 className="text-2xl font-bold tracking-tight">{title}</h1>
        {subtitle && <p className="text-sm text-muted-foreground mt-1">{subtitle}</p>}
      </div>
      {action && <div>{action}</div>}
    </div>
  );
}
